import { render, staticRenderFns } from "./insurer-plan-commission.vue?vue&type=template&id=3c997693&scoped=true&"
import script from "./insurer-plan-commission.vue?vue&type=script&lang=js&"
export * from "./insurer-plan-commission.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan-commission.vue?vue&type=style&index=0&id=3c997693&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c997693",
  null
  
)

export default component.exports